import { AuthTopNavigation } from '../auth-top-navigation/AuthTopNavigation'
import {
  useForgotPassword,
  type ForgotPasswordRequest,
} from './forgot-password-form/useForgotPasword'
import { useNavigate } from 'react-router-dom'
import { ForgotPasswordForm } from './forgot-password-form/ForgotPasswordForm'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { ForgotInfoSection } from './forgot-info/ForgotInfo'

function ForgotPasswordPage() {
  const navigate = useNavigate()
  const { setNotification } = useLocalNotifications()
  const { isRequesting, error, sendForgotPasswordEmail } = useForgotPassword()

  function handleSendForgotPasswordEmail(props: ForgotPasswordRequest) {
    sendForgotPasswordEmail(props, {
      onSuccess: () => {
        setNotification(
          'success',
          'V prípade, ak užívateľ existuje, email na obnovu hesla sa odoslal'
        )
        navigate('/login')
      },
    })
  }

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="flex items-start col-span-1">
        <div className="flex flex-col justify-center items-center gap-0 lg:gap-[60px] w-full">
          <AuthTopNavigation />
          <div className="flex flex-col gap-10 lg:gap-6 w-full lg:w-[400px] md:px-5 lg:px-0 lg:py-auto pb-10 lg:pb-20">
            <ForgotPasswordForm
              isRequesting={isRequesting}
              handleSubmitForm={handleSendForgotPasswordEmail}
              error={error}
            />
          </div>
        </div>
      </div>

      <div className="hidden lg:flex lg:col-span-1 justify-center items-center md:px-20 bg-foreground text-primary-foreground">
        <ForgotInfoSection />
      </div>
    </div>
  )
}

export default ForgotPasswordPage
